import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    strokeWidth="1.2"
    strokeLinecap="round"
    fill="transparent"
    stroke="currentColor"
    {...props}
  >
    <path d="M3.00004 12.4H5.36268C5.44544 12.4 5.51964 12.349 5.54935 12.2718L6.84483 8.90355C6.90602 8.74445 7.12545 8.72993 7.20708 8.87957L9.80472 13.6419C9.88433 13.7879 10.0969 13.7786 10.1635 13.6263L13.3289 6.39121C13.3969 6.23586 13.6152 6.23026 13.691 6.38193L14.9448 9.88945C14.9786 9.9572 15.0479 10 15.1236 10H17M3.25 19H16.75C17.9926 19 19 17.9926 19 16.75V3.25001C19 2.00737 17.9926 1.00001 16.75 1.00001H3.25C2.00736 1.00001 1 2.00737 1 3.25001V16.75C1 17.9926 2.00736 19 3.25 19Z" />
  </svg>
);
